import React, { useRef, useState } from "react";
import Hero from "../../Component/WebHomePage/Hero/Hero.jsx";
import HowItWorks from "../../Component/WebHomePage/HowItWorks/HowItWorks.jsx";
import NewNavbar from "../../Component/WebHomePage/Navbar/NewNavbar.jsx";
import WhyClaimPro2 from "../../Component/WebHomePage/WhyClaimpro/WhyClaimpro.jsx";
import ServicesCard from "../../Component/WebHomePage/Services/ServicesCard.jsx";
import Network from "../../Component/WebHomePage/Network/Network.jsx";
import MeetClaimProTeam from "../../Component/WebHomePage/MeetClaimProTeam/MeetClaimProTeam.jsx";
import BlogImg1 from "../../Assets/home/BlogImg1.jpg";
import BlogImg2 from "../../Assets/home/BlogImg2.jpg";
import Blog3 from "../../Assets/home/Blog3.jpg";

import img1 from "../../Assets/home/img1.png";
import rightarrow from "../../Assets/navbar/right-arrow.svg";
import logo from "../../Assets/home/logo.svg";
import img2 from "../../Assets/home/img2.png";
import item1 from "../../Assets/home/item1.svg";
import item2 from "../../Assets/home/item2.svg";
import item5 from "../../Assets/home/item5.png";
import item3 from "../../Assets/home/item3.svg";
import item4 from "../../Assets/home/item4.svg";
import item8 from "../../Assets/home/item8.svg";
import img7 from "../../Assets/home/img7.png"
import Navbar from "../../Component/Home/Navbar";
import Footer from "../../Component/WebHomePage/Footer/Footer.jsx";
import HdfcPaymentButton from "../Customers/PaymentPage/HDFCPaymentButton";
import { useEffect } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { validateToken } from "../../Auth/authUtils";
import axios from "../../axiosInstance";
import DownloadPdfButton from "../../Component/Customers/DownloadPDFButton";
import Marquee from "react-fast-marquee";
import EmergencyNetwork from "../../Component/WebHomePage/EmergencyNetwork/EmergencyNetwork";
import StoryChapters from "../../Component/WebHomePage/StoryChapters/StoryChapters";

function Home() {
  const navigate = useNavigate();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const scrollRef = useRef();

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const checkLogin = async () => {
      const isValid = await validateToken();
      const userRole = localStorage.getItem("userRole");
      const currentStep = localStorage.getItem("currentStep");

      if (isValid) {
        console.log("currentstepa", currentStep);

        if (userRole === "customer") {
          navigate("/customer-home-page", { replace: true });
        } else if (["Management", "IT", "Operations", "HR", "KAM"].includes(userRole)) {
          navigate("/admin-dashboard-vendor-customer", { replace: true });
        } else if (userRole === "recoveryVan") {
          navigate("/crane-driver-home", { replace: true });
        } else if (userRole === "craneandrecoveryVan") {
          navigate("/crane-driver-home", { replace: true });
        } else if (userRole === "vendorDriver") {
          navigate("/vendor-driver-home", { replace: true });
        } else {
          localStorage.clear();
          sessionStorage.clear();
          navigate("/loginPage", { replace: true });
        }
      } else {
        setIsCheckingAuth(false); // show login form only if not logged in
      }
    };

    checkLogin();
  }, []);

  const impactRef = useRef(null);
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const newsRef = useRef(null);

  // Scroll handler
  const scrollToImpact = () => {
    if (impactRef.current) {
      impactRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollToAbout = () => {
    if (aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollToHome = () => {
    if (homeRef.current) {
      homeRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollToNews = () => {
    if (newsRef.current) {
      newsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const location = useLocation();

  // Auto scroll when redirected with scroll state
  useEffect(() => {
    if (location.state?.scrollTo === "about") {
      // Delay scroll slightly to ensure DOM is ready
      setTimeout(() => {
        // scrollToImpact();
        scrollToAbout();

        // Clean up state so back button doesn't trigger again
        navigate(location.pathname, { replace: true, state: {} });
      }, 100); // 100ms is usually safe
    }
    if (location.state?.scrollTo === "home") {
      // Delay scroll slightly to ensure DOM is ready
      setTimeout(() => {
        scrollToHome();

        // Clean up state so back button doesn't trigger again
        navigate(location.pathname, { replace: true, state: {} });
      }, 100); // 100ms is usually safe
    }
  }, [location, navigate]);

  return (
    <>
      {isCheckingAuth ? (
        <div />
      ) : (
        <>
          <NewNavbar />
          <section id="home">
            <Hero />
          </section>
          <HowItWorks />
          <WhyClaimPro2 />
          <section id="services">
            <ServicesCard />
          </section>
          <Network />
          <StoryChapters />
          <section id="team">
            <MeetClaimProTeam />
          </section>
          <section id="contact">
            <Footer
              onAboutClick={scrollToAbout}
              onHomeClick={scrollToHome}
              onNewsClick={scrollToNews}
            />
          </section>
        </>
      )}
    </>
  );
}

export default Home;
